import { Clock } from "lucide-react";
import RemindersModal from "./RemindersModal";
import { useState } from "react";
import RemindersContext from "../../../../_helper/Reminders";
import { useContext } from "react";
import styles from "./RemindersHeader.module.scss";

const RemindersHeader = ({ className }) => {
  const remindersCtx = useContext(RemindersContext);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const count = remindersCtx?.upcomingCount || 0;
  return (
    <li className={className ? `${className} ${styles.host}` : styles.host} onClick={toggleModal}>
      <span className="header-count-anchor">
        <Clock className="header-icon" />
        {count > 0 && <span className="header-count-badge">{count}</span>}
      </span>
      <RemindersModal isOpen={modalOpen} toggle={toggleModal} />
    </li>
  );
};

export default RemindersHeader;
